export const KIOSK_DEVICE_STORAGE_KEY = 'kiosk:device-session';
export const KIOSK_BATCH_STORAGE_KEY = 'kiosk:device-batch';

let handoff: string | null = null;
const handoffListeners = new Set<() => void>();

export function onKioskHandoff(listener: () => void): () => void {
  handoffListeners.add(listener);
  return () => {
    handoffListeners.delete(listener);
  };
}

export function installKioskHandoffListener(): () => void {
  // Fragment navigation emits popstate before hashchange. Capture before Angular's
  // location listener snapshots the URL, or its queued navigation restores the spent code.
  window.addEventListener('popstate', captureKioskEntry);
  window.addEventListener('hashchange', captureKioskEntry);
  return () => {
    window.removeEventListener('popstate', captureKioskEntry);
    window.removeEventListener('hashchange', captureKioskEntry);
  };
}

export function isKioskEntry(path = window.location.pathname): boolean {
  return /^\/kiosk(?:\/[lb]\/[^/]+|\/batch)?\/?$/.test(path);
}

/** Runs before importing the application or telemetry, including after gallery URL preparation. */
export function captureKioskEntry(): void {
  if (!isKioskEntry() || !window.location.hash) return;
  const fragment = new URLSearchParams(window.location.hash.slice(1));
  if (fragment.has('code')) {
    handoff = fragment.get('code') ?? '';
    try {
      // Do this before stripping the replacement code: an interrupted bootstrap must
      // never resume the previous patient's credential on the next document load.
      sessionStorage.removeItem(KIOSK_DEVICE_STORAGE_KEY);
      sessionStorage.removeItem(KIOSK_BATCH_STORAGE_KEY);
      sessionStorage.removeItem('kiosk:session');
    } catch {
      // Keep the fragment when storage cannot be cleared, so a refresh cannot fall
      // back to the old credential. The empty in-memory handoff fails closed.
      handoff = '';
      handoffListeners.forEach(listener => listener());
      return;
    }
  }
  window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
  if (fragment.has('code')) handoffListeners.forEach(listener => listener());
}

export function takeKioskHandoff(): string | null {
  const code = handoff;
  handoff = null;
  return code;
}
